const { cELM } = require("../../utils");
const Chat = require("../../chat");

class YesNoTranslated {
  constructor(data, callback) {
    this._data = data;
    this.options = data.values.split("|");
    this.element = cELM("div", "option-block");
    this.callback = callback;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;

    const yesOptionName = this.options[0].trim();
    const yesButton = cELM("div", "button", yesOptionName);
    yesButton.onclick = function(evt) {
        const data = {
            displayName: yesOptionName,
            value: 'yes'
        };
        Chat.default.send(data, null, _self.element);

        if (_self.callback) {
            _self.callback(yesOptionName);
        }
    };
    this.element.addELM(yesButton);

    const noOptionName = this.options[1].trim();
    const noButton = cELM("div", "button", noOptionName);
    noButton.onclick = function(evt) {
        const data = {
            displayName: noOptionName,
            value: 'no'
        };
        Chat.default.send(data, null, _self.element);

        if (_self.callback) {
            _self.callback(noOptionName);
        }
    };
    this.element.addELM(noButton);

    return this.element;
  }

  reset() {}
  focus() {}
}

module.exports = YesNoTranslated;
